import { useState } from 'react'
import { useMatches } from 'react-router-dom'
import { menuList } from '@/routes/menuLIst.config'
import { type BreadcrumbItemType } from 'antd/lib/breadcrumb/Breadcrumb'
import { useDebounceEffect } from 'ahooks'

const useRecoveredMenuState = () => {
  const matches = useMatches()

  const [selectedKeys, setSelectedKeys] = useState<string[]>([])
  const [openKeys, setOpenKeys] = useState<string[]>([])
  const [breadCrumb, setBreadCrumb] = useState<BreadcrumbItemType[]>()

  useDebounceEffect(
    () => {
      const currentMatch = matches.length > 0 ? matches[matches.length - 1] : undefined
      const currentPath = currentMatch?.pathname
      if (!currentPath) return

      // 根据路径判断来源页面
      if (currentPath.includes('/message')) {
        // 设置卡证数据源菜单展开
        setOpenKeys(['bankCardSourceData'])

        // 根据路径判断具体是哪个父页面并设置面包屑
        if (currentPath.includes('highRiskBankCard')) {
          setSelectedKeys(['highRiskBankCard'])
          setBreadCrumb([
            {
              title: '卡证数据源 / 高危卡号 / 原始消息',
              href: `${BASE_PATH}/highRiskBankCard/message`
            }
          ])
        } else if (currentPath.includes('highRiskIdentityCards')) {
          setSelectedKeys(['highRiskIdentityCards'])
          setBreadCrumb([
            {
              title: '卡证数据源 / 高危身份证 / 原始消息',
              href: `${BASE_PATH}/highRiskIdentityCards/message`
            }
          ])
        } else if (currentPath.includes('transferReceiptInformation')) {
          setSelectedKeys(['transferReceiptInformation'])
          setBreadCrumb([
            {
              title: '卡证数据源 / 转账详情 / 原始消息',
              href: `${BASE_PATH}/transferReceiptInformation/message`
            }
          ])
        }
        return
      }

      // 其他页面的原有逻辑
      const currentId = currentMatch?.id
      if (!currentId) return
      const matchedRoute = menuList.find((item) => item.id === currentId)
      if (!matchedRoute) return
      let matchedOpenKey: string | undefined, matchedSelectedKey: string | undefined
      if (matchedRoute.menu === false) {
        if (matchedRoute.parentId) {
          matchedOpenKey = matchedRoute.parentId
          matchedSelectedKey = matchedRoute.parentId
        }
      } else {
        matchedSelectedKey = matchedRoute.id
        if (matchedRoute.parentId) {
          matchedOpenKey = matchedRoute.parentId
        }
      }
      setBreadCrumb(matchedRoute.breadCrumb)
      if (matchedOpenKey != null && !openKeys.includes(matchedOpenKey)) {
        setOpenKeys((prev) => [...prev, matchedOpenKey] as string[])
      }
      if (matchedSelectedKey != null && !selectedKeys.includes(matchedSelectedKey)) {
        setSelectedKeys([matchedSelectedKey] as string[])
      }
    },
    [matches],
    {
      wait: 10
    }
  )

  return {
    selectedKeys,
    openKeys,
    breadCrumb,
    module,
    setOpenKeys,
    setSelectedKeys
  }
}

export default useRecoveredMenuState
